import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';

const EditTerritory = (props) => {
  const curState = props.curState;
  const editData = curState ? curState.editData ? curState.editData[0] : null  : null;
  // console.log(editData);
  return (
    <Modal size="sm" show={props.modelOpen} onHide={props.toggleModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> Edit <span className="ml-2 badge badge-info"> Forecast Name & Year </span>  </h5>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label> Target </label>
                    <input type="text" name="target_value" value={editData ? editData.target_value : ''} onChange={e=>props.editTerritoryChangeHandler(e,0)} className="form-control" />
                  </div>
                </div>
              </div> 
            </Modal.Body>
            <Modal.Footer>
               <div className="ml-md-auto py-2 py-md-0">
                  <a onClick={e=>props.toggleModel(null)} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a> 
                  <a onClick={e=>props.updateHandler('hier')} className="btn primary_bg"> Save </a>
                    
                </div>
            </Modal.Footer>
    </Modal>
  );
}

export default withRouter(EditTerritory);